import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Upload from 'apollo-react-icons/Upload';
import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openAttachmentModal } from '../../actions/EntityDisplayActions';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { FORM_KEYS } from '../../form-designer/constants/form-manager.constants';
import { getNetworkStatus } from '../../form-designer/selectors/common.selectors';
import { getIsDownloadInOfflineAvailableForEntity } from '../../form-designer/selectors/form-manager.selectors';
import { getAttachmentGrid } from '../../form-designer/selectors/runtime.selectors';

const useStyles = makeStyles({
  root: {
    '& .MuiButton-label': {
      left: -2,
    },
  },
  fullWidth: {
    width: '100%',
  },
});

const AttachmentButton = ({ fullWidth }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const formHasAttachmentGrid = useFormSelector(getAttachmentGrid, { formKey: FORM_KEYS.STEP });
  const isDownloadInOfflineAvailableForEntity = useFormSelector(
    getIsDownloadInOfflineAvailableForEntity
  );
  const isOnline = useSelector(getNetworkStatus);

  return formHasAttachmentGrid ? (
    <Button
      variant="secondary"
      color="secondary"
      icon={Upload}
      onClick={() => dispatch(openAttachmentModal())}
      className={classNames(classes.root, fullWidth ? classes.fullWidth : '')}
      disabled={!isDownloadInOfflineAvailableForEntity && !isOnline}
    >
      {translateString('Attachment')}
    </Button>
  ) : null;
};

export default AttachmentButton;
